/**
 * The one App Store address for Grounded.
 *
 * Every download link in the app must import this. A guard test
 * (src/lib/__tests__/appStoreUrl.test.ts) fails the build if the URL is typed
 * by hand anywhere else, or if the old 404ing /app/grounded link comes back.
 */
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/grounded-remote-work-cafes/id6759308140";
